import { gql, useLazyQuery } from '@provision/graphql-client';
import { useCallback } from 'react';

const GET_AI_MESSAGE_COMPOSITION = gql`
  query GetAiMessageComposition($params: GetAiMessageCompositionInput!) {
    getAiMessageComposition(params: $params) {
      aiMessage
      responseId
    }
  }
`;

interface GetAiMessageCompositionQuery {
  getAiMessageComposition: {
    aiMessage: string;
    responseId?: string;
  };
}

export const useAiMessageComposition = () => {
  const [getComposition, { ...rest }] = useLazyQuery<GetAiMessageCompositionQuery>(
    GET_AI_MESSAGE_COMPOSITION,
    {
      fetchPolicy: 'no-cache',
      context: {
        ttl: 0,
      },
    },
  );

  const getAiMessageComposition = useCallback(
    ({
      partnerId,
      userId,
      conversationId,
      conversationMessageId,
      promptId,
      customPrompt,
      userInput,
      correction,
      previousResponseId,
    }: {
      partnerId: number;
      userId: string;
      conversationId: string;
      conversationMessageId?: string;
      promptId?: string;
      customPrompt?: string;
      userInput?: string;
      correction?: string;
      previousResponseId?: string;
    }) => {
      return getComposition({
        variables: {
          params: {
            partnerId,
            userId,
            conversationId,
            conversationMessageId,
            promptId,
            customPrompt,
            userInput,
            correction,
            previousResponseId,
          },
        },
      });
    },
    [getComposition],
  );

  return {
    getAiMessageComposition,
    ...rest,
  };
};
